<qai-results-tab [title]="'results.SKILLS' | transloco">
  @for (skill of viewSkills; track skill.title) {
    <qai-section-header
      [subtitle]="skill.title"
      [subtitleIndicator]="skill.scoreIndicator"
      [border]="true"
    />
    <qai-label>{{ skill.feedback }}</qai-label>
  }
</qai-results-tab>
